<template>
  <div class="page-compoment">
    <div class="head">
      <div class="head-logo"></div>
      <div class="head-title">
        <img :src="config.logo" alt="">
      </div>
    </div>
    <div class="nav">
      <div class="nav-box">
        <router-link to="/home" active-class="active">
          <div class="nav-box-item">
            <span>首页</span>
          </div>
        </router-link>
        <div class="nav-box-item">
          <span>关于我们</span>
          <div class="nav-box-item-son">
            <router-link to="/desc" active-class="active">
              <div class="padding">
                <div class="item">公司简介</div>
              </div>
            </router-link>
            <router-link to="/project" active-class="active">
              <div class="padding">
                <div class="item">投资项目</div>
              </div>
            </router-link>
            <router-link to="/cooperation" active-class="active2">
              <div class="padding">
                <div class="item">合作伙伴</div>
              </div>
            </router-link>
            <router-link to="/contact" active-class="active">
              <div class="padding">
                <div class="item">联系我们</div>
              </div>
            </router-link>
          </div>
        </div>
        <router-link to="/news" active-class="active">
          <div class="nav-box-item">
            <span>新闻中心</span>
          </div>
        </router-link>
        <div class="nav-box-item">
          <span>盛目慈善</span>
          <div class="nav-box-item-son">
            <router-link to="/charitable" active-class="active">
              <div class="padding">
                <div class="item">基金会</div>
              </div>
            </router-link>
          </div>
        </div>
        <router-link to="/recruit" active-class="active">
          <div class="nav-box-item">
            <span>人才招聘</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['config'])
  }
}
</script>

<style lang="scss" scoped>
  .page-compoment {
    .head {
      padding: 20px 0;
      box-sizing: border-box;
      width: 1200px;
      margin: auto;
      &-title {
        // font-weight: 700;
        // font-size: 25px;
        // color: #2474cf;
        height: 25px;
        img {
          height: 100%;
          width: auto;
        }
      }
    }
    a {
      color: #fff;
      display: block;
      text-decoration: none;
    }
    .nav {
      background-color: #2474cf;
      height: 50px;
      .nav-box {
        display: flex;
        color: #fff;
        justify-content: flex-end;
        width: 1000px;
        margin: 0 auto;
        &-item {
          line-height: 50px;
          // min-width: 100px;
          padding: 0 30px;
          cursor: pointer;
          position: relative;
          &-son {
            width: 100%;
            background-color: #e1e7f1;
            position: absolute;
            top: 100%;
            left: 0;
            display: none;
            z-index: 999;
            .active2 {
              background-color: #f0f2f5;
            }
            .padding {
              padding: 0 10px;
              box-sizing: border-box;
            }
            .padding:hover {
              background-color: #f0f2f5;
            }
            .item {
              color: #2474cf;
              text-align: center;
              border-bottom: 1px solid #2474cf;
            }
            a:nth-last-of-type(1) {
              .item {
                border: none;
              }
            }
          }
        }
        &-item:hover {
          background: #92b8e4;
          .nav-box-item-son {
            display: block !important;
          }
        }
        .active {
          background: #fff;
          color: #000;
        }
      }
    }
  }
</style>
